import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import b from 'b_';

import { Researcher } from '@interfaces/researchers-page';
import Theme from '@interfaces/themes';

import './researcher.css';

interface ResearchersProps {
    entity: Researcher;
}

const class_ = b.with('researcher');

export default class ResearcherBlock extends Component<ResearchersProps> {
    public shouldComponentUpdate() {
        return true;
    }

    public render() {
        const { entity: researcher } = this.props;
        const url = `/people/${researcher.id}`;
        const photoUrl = researcher.photo || '/no-avatar.png';

        return (
            <div key={researcher.id} className={class_()}>
                <Link
                    className={class_('image')}
                    to={url}
                    style={{ backgroundImage: `url(${photoUrl})` }}
                />
                <div className={class_('content')}>
                    <Link className={class_('name')} to={url}>
                        {this.getResearcherFullName(researcher)}
                    </Link>
                    <div className={class_('job')}>{this.getResearcherJob(researcher)}</div>
                    <div>{this.renderThemes(researcher.themes)}</div>
                </div>
            </div>
        );
    }

    private getResearcherFullName({ firstName, lastName }: Researcher) {
        return `${firstName} ${lastName}`;
    }

    private getResearcherJob({ jobPlace, jobPosition }: Researcher) {
        return [jobPlace, jobPosition].filter(Boolean).join(' • ');
    }

    private renderThemes(themes: Theme[]) {
        return themes.map(({ slug, title }: Theme) => (
            <a
                key={slug}
                className={class_('theme')}
                href={`/publications?themeSlug=${slug}`}
            >
                {title}
            </a>
        ));
    }
}
